import { render } from "./CartHeaderPrice.vue?vue&type=template&id=3e245237"
import script from "./CartHeaderPrice.vue?vue&type=script&lang=js"
export * from "./CartHeaderPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__